/**
 * Minifigs 2.0 - Apply torso image overlay to product media gallery items
 *
 *
 * @author Matt Haynes <matthew.haynes@joipolloi.com>
 * @package Joi Polloi
 */

const torsoMediaOverlays = () => {
    const imageOverlays = Array.from(document.querySelectorAll('.imageOverlay'));
    if (!imageOverlays || imageOverlays.length === 0) return;

    const docRoot = document.querySelector(':root');
    imageOverlays.forEach((overlay) => {
        const overlaySrc = overlay.dataset.overlay;
        let name = 'default';
        if (overlaySrc.includes('Colour')) {
            name = 'Colour';
        } else if (overlaySrc.includes('Dark')) {
            name = 'Dark';
        }

        docRoot.style.setProperty(`--overlay-${name}`, `url(${overlaySrc})`);
    });

    // Get main swiper and thumbnail slides
    const mainSlides = Array.from(document.querySelectorAll('.swiper-product-media-gallery .swiper-slide'));
    const thumbSlides = Array.from(document.querySelectorAll('.swiper-product-media-thumbs .swiper-slide'));

    const len = window.location.pathname.split('/').length;
    const handle = window.location.pathname.split('/')[len - 1];

    const getMetafield = async () => {
        try {
            const resp = await fetch('/api/2025-04/graphql.json', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/graphql',
                    'Access-Control-Origin': '*',
                    'X-Shopify-Storefront-Access-Token': 'e14901ef020f42eff2b10fbed13e6e18',
                },
                body: query(handle),
            });

            return await resp.json();
        } catch (err) {
            console.log('Fetch Error :-S', err);
        }
    };

    getMetafield().then((res) => {
        const variants = res.data.product?.variants?.nodes || [];
        if (!variants.length) return;

        // Process main slides first
        mainSlides.forEach((slide, index) => {
            // Skip the first slide (product thumbnail)
            if (slide.classList.contains('product-thumbnail')) return;

            const imageCompare = slide.dataset.imagecompare;

            if (imageCompare) {
                variants.forEach((variant) => {
                    if (variant.image.url.includes(imageCompare) && variant.torsoOverlayValue) {
                        const overlayValue = variant.torsoOverlayValue.value;
                        slide.dataset.overlaytheme = overlayValue;

                        if (overlayValue === 'Dark') {
                            slide.classList.add('torsoOverlayValue__dark');
                        } else if (overlayValue === 'Light') {
                            slide.classList.add('torsoOverlayValue__colour');
                        }

                        // Find the matching thumbnail slide and apply the same overlay
                        // Thumbnail slides are in the same order as main slides
                        if (thumbSlides[index]) {
                            thumbSlides[index].dataset.overlaytheme = overlayValue;
                            if (overlayValue === 'Dark') {
                                thumbSlides[index].classList.add('torsoOverlayValue__dark');
                            } else if (overlayValue === 'Light') {
                                thumbSlides[index].classList.add('torsoOverlayValue__colour');
                            }
                        }
                    }
                });
            }
        });
    });
};

export default torsoMediaOverlays;

const query = (handle) => {
    return `{
        product(handle: "${handle}") {
            id    
            variants(first: 50) {
                nodes {
                    id
                    torsoOverlayValue: metafield(
                        namespace: "custom"
                        key: "torso_overlay"
                    ) {
                        value
                    }
                    image {
                        altText
                        url
                    }
                }
            }
        }
    }`;
};
